import '@/assets/css/style.css'
import '@/assets/fonts/signature/signature-fonts.css'
import '@/assets/fontawesome/css/fontawesome.css'
import '@/assets/fontawesome/css/brands.css'
import '@/assets/fontawesome/css/solid.css'
import 'mapbox-gl/dist/mapbox-gl.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import canDirective from '@/directives/can'

axios.defaults.withCredentials = true

const app = createApp(App)

const requireComponent = require.context('./components', true, /\.vue$/)

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName
    .split('/')
    .pop()
    .replace(/\.\w+$/, '')
  app.component(componentName, componentConfig.default || componentConfig)
})

app.use(store)
app.use(router)
app.directive('can', canDirective)

app.mount('#app')
